import { render } from 'react-dom';
import { AutoOpenModal, AutoOpenModalProps } from './Modal';
import React from 'react';
import { ThemeProvider } from 'styled-components';
import { theme as themeStyle } from '../../themes/themes';

export function createWrapperAndAppendToBody(wrapperId: string) {
  const wrapperElement = document.createElement('div');
  wrapperElement.setAttribute('id', wrapperId);
  document.body.appendChild(wrapperElement);
  return wrapperElement;
}

const reactRoot = (children: any, wrapperId = 'react-root') => {
  let element = document.getElementById(wrapperId);
  // if element is not found with wrapperId,
  // create and append to body
  if (!element) {
    element = createWrapperAndAppendToBody(wrapperId);
  }

  return render(children, element);
};

export const showModal = (options: AutoOpenModalProps, themeOverride: any = themeStyle, wrapperId = 'modal-root') => {
  reactRoot(
    <ThemeProvider theme={themeOverride}>
      <AutoOpenModal {...options} key={Date.now()} />
    </ThemeProvider>,
    wrapperId
  );
};
